<template>
  <div>
    <el-popover
      placement="bottom"
      trigger="click"
      popper-class="subject-popover"
      :visible-arrow="false"
      v-model="popoverVisible"
    >
      <div class="subject-list">
        <div
          v-for="(item, index) in list"
          :key="item.value"
          class="subject-item"
          :class="{
            active: selectedItem === item.value,
            noMargin: index === list.length - 1,
          }"
          @click="selectSubject(item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div slot="reference" class="subject-trigger">
        <span class="subject-label" :class="{ 'subject-label-active': selectedItem !== 0 }">
          {{ selectedItemName }}
        </span>
        <i
          class="sel-arrow"
          :class="{
            'el-icon-caret-top': popoverVisible,
            'el-icon-caret-bottom': !popoverVisible,
          }"
        ></i>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'MemberStoveCourseSelect',
  data() {
    return {
      popoverVisible: false,
      selectedItem: 0,
    };
  },
  computed: {
    selectedItemName() {
      if (this.selectedItem === 0) {
        return this.defaultItemName;
      }
      return this.list.find((item) => item.value === this.selectedItem)?.label || '';
    },
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    defaultItemName: {
      type: String,
      default: '请选择',
    },
  },
  methods: {
    selectSubject(item) {
      if (this.selectedItem === item.value) return;
      this.selectedItem = item.value;
      this.popoverVisible = false;
      this.$emit('on-change', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.subject-selector {
  display: inline-block;
  position: relative;
}

.subject-trigger {
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 4px;

  .sel-arrow {
    font-size: 11px;
    color: #1d1b20;
    transition: transform 0.3s;
  }

  .subject-label {
    margin-right: 2px;
    color: #1d1b20;
    font-size: 14px;
    min-width: 42px;
    text-align: right;
  }

  .subject-label-active {
    color: #ff2020;
    & + .sel-arrow {
      color: #ff2020;
    }
  }
}

.subject-list {
  width: 114px;
  max-height: 192px;
  overflow-y: auto;
  padding: 16px;

  .subject-item {
    padding: 4px 8px;
    text-align: center;
    margin-bottom: 16px;
    background-color: #f1f3f9;
    border-radius: 20px;
    line-height: 22px;

    cursor: pointer;
    font-size: 12px;
    color: #000;
    transition: all 0.3s;

    &:hover {
      background-color: #f5f7fa;
    }

    &.active {
      background-color: #ffefef;
      color: #ff2020;
      font-weight: 500;
    }

    &.noMargin {
      margin-bottom: 0;
    }
  }
}
</style>

<style lang="scss">
/* 全局样式，确保弹出框样式正确 */
.subject-popover {
  padding: 0;
  min-width: 100px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
